import '../styles/BatuInfoStyle.css';
import LogoMain from '../../resources/images/LogoMain.svg';
import { FormButton } from '../common';
import { useActions } from '../../hooks';
import { useAuthenticator } from '@aws-amplify/ui-react';

const WELCOME_MESSAGE = 'La forma más fácil para consultar recibos de CFE';

const BatuInfo: React.FC = () => {
  const { userNeedsRegistration } = useActions();
  const { route } = useAuthenticator((context) => [context.route]);
  const renderBottomContainer = () => {
    if (route !== 'authenticated') {
      return (
        <div className="request-bill-info-bottom-container">
          <FormButton
            content="Registrarme"
            disabled={false}
            onSubmit={() => {
              userNeedsRegistration(true);
            }}
          />
        </div>
      );
    }
  };
  return (
    <div className="request-bill-info-container">
      <div className="request-bill-info-top-container">
        <div className="request-bill-info-logo-container">
          <img
            src={LogoMain}
            alt="Batu logo"
            className="request-bill-info-logo"
          />
        </div>
        <div className="request-bill-info-box">
          <h3 className="request-bill-info-title">{WELCOME_MESSAGE}</h3>
        </div>
      </div>
      {renderBottomContainer()}
      <div className="request-bill-info-divider" />
    </div>
  );
};
export { BatuInfo };
